import dayjs from 'dayjs';
import React, { useState } from 'react';

import styles from './BookAppointment.module.scss';
import getRandomSalesAgent from '../../api/ClientBookAppointment/getRandomSalesAgent.api';

function TimeButton({
	time,
	timeToBeDisabled,
	setClickedTime,
	clickedTime,
	setSelectTime,
	selectTime,
	setTimeText,
	timeText,
	handleConfirm,
	bookedTimeList,
	setOpenDetailsForm,
	setConfirmedTime,
	// setDisabled,
	setSalesAgentsChosen,
}) {
	const handleClickTime = (e) => {
		setClickedTime(true);
		var text = e.currentTarget.dataset.time;
		setTimeText(text);
		getRandomSalesAgent(text, (returned) => setSalesAgentsChosen(returned));
	};

	const styleDisableButton = () => {
		if (timeToBeDisabled?.includes(parseInt(time))) {
			return { opacity: '0.5', backgroundColor: 'grey' };
		}
	};

	return (
		<div className={styles.select_time_wrapper}>
			<div
				className={
					timeToBeDisabled?.includes(parseInt(time)) === true
						? `${styles.select_time} ${styles.disabled}`
						: `${styles.select_time} `
				}
				style={{ ...styleDisableButton() }}
				onClick={(e) => {
					handleClickTime(e);
				}}
				data-time={time}
			>
				<p>{dayjs(time).format('hh:mma')}</p>
			</div>
			{clickedTime === true && parseInt(timeText) === parseInt(time) && (
				<div
					className={`${styles.select_time} ${styles.confirm}`}
					data-time={time}
					onClick={(e) => {
						setOpenDetailsForm(true);
						setConfirmedTime(time);
						// setDisabled(true);
						setClickedTime(false);
					}}
				>
					<p>Choose</p>
				</div>
			)}
		</div>
	);
}

export default TimeButton;
